import React, { useEffect, useRef, useState } from 'react';
import {useTranslation} from "react-i18next";
import {BUTTON_PRIMARY, LUGGAGE_USE_CASE, SUCCESS, TOAST_ERROR} from "../assets/constants/Constants";
import {QR_CODE_LANDING, LOGIN, LOCKER_DETAILS} from '../assets/constants/PageList';
import { LOCAL_STORAGE, IS_LOGGED_IN, LOCKER_SLUG, LOCKER_BANK_ADDRESS, LS_LOCKER_BANK_INFO } from "../assets/constants/BrowserStorageKeys";
import { getSecureItemFromSpecificStorage, storeSecureItemInSpecifiedStorage } from "../lib/BrowserStorageAccessMiddleware";
import { checkIfAssignmentIsProperlyConfigured, getPathForNextPage, isValidDomainAndLockerBankId, setDomainAndLockerBankIdInLocalStorage, applyBackendLanguageConfig, GetAvailableLockerSizesAndRedirectUser, buildAddress, buildLockerDetailsData, redirectToLockerDetails, getUnitLabelParams } from "../lib/Utils";
import { useHistory, useParams } from 'react-router-dom';
import { getTenantAndAssignmentSettings } from '../api/api';
import ShowToast from '../components/ToastComponent';
import CustomDialog from '../components/CustomDialog';
import { Box } from '@mui/material';
import CircularProgressLoader from '../components/CircularProgressLoader';

const LandingPage = () => {
    const history = useHistory();
    const { domainAndLockerBankInfoInBase64 } = useParams();
    const {t} = useTranslation();
    const initialRender = useRef(true);
    const [dialogVisible, setDialogVisible] = useState(false);
    const [dialogContentText, setDialogContentText] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [loadingMessage, setLoadingMessage] = useState(t('pleaseWaitText'));


    const validateDomainAndLockerBankId = async () => {
        try {
            let domainAndLockerBankInformation = window.atob(domainAndLockerBankInfoInBase64);
            if (isValidDomainAndLockerBankId(domainAndLockerBankInfoInBase64)) {
                const domainAndLockerBankInfoObject = JSON.parse(domainAndLockerBankInformation);
                setDomainAndLockerBankIdInLocalStorage(domainAndLockerBankInfoObject);
                const response = await getTenantAndAssignmentSettings(domainAndLockerBankInfoObject?.lockerBankId)
                if(response.status === SUCCESS){
                    applyBackendLanguageConfig(response);
                    const lockerAssignments = response?.data?.locker_assignments || [];
                    const lockerslug = response?.data?.locker_bank?.slug;
                    const tempResponse = response?.data?.locker_bank;
                    const lokcerCurrency = response?.data?.locker_assignments[0]?.currency || '';
                    const lockerBankAddress = buildAddress(response?.data?.locker_bank);
                    storeSecureItemInSpecifiedStorage(LOCAL_STORAGE, LOCKER_SLUG, lockerslug);
                    storeSecureItemInSpecifiedStorage(LOCAL_STORAGE, LOCKER_BANK_ADDRESS, lockerBankAddress);

                    if (lockerAssignments.length > 1) {
                        setIsLoading(false);

                        history.replace({
                            pathname: '/assignments',
                            state: {
                                tenantAndAssignmentSettings: response?.data
                            }
                        });
                    }
                    else if (lockerAssignments.length === 1) {
                        const isAssignmentProperlyConfigured = await checkIfAssignmentIsProperlyConfigured(response?.data);

                        if (isAssignmentProperlyConfigured === true) {
                            const templockerData = buildLockerDetailsData(tempResponse, lockerBankAddress, domainAndLockerBankInfoObject?.domain);
                            setIsLoading(false);
                            if(response?.data?.locker_assignments[0]?.usecase === LUGGAGE_USE_CASE){
                                const redirectionPathname = getPathForNextPage(QR_CODE_LANDING, LOCKER_DETAILS);
                                await redirectToLockerDetails(history, 'replace', templockerData, lokcerCurrency, redirectionPathname);
                                
                            }else{
                                const redirectionPath = getPathForNextPage(QR_CODE_LANDING, LOGIN);
                                history.push({
                                    pathname: redirectionPath
                                });
                            }
                        }
                        else {
                            setIsLoading(false);
                            setDialogContentText( t(isAssignmentProperlyConfigured?.errorMessage, getUnitLabelParams(tempResponse?.bank_type, t)) );
                            setDialogVisible(true);
                        }
                    }
                    else {
                        setIsLoading(false);
                        setDialogContentText( t('noLockerAssignments', getUnitLabelParams(tempResponse?.bank_type, t)) );
                        setDialogVisible(true);
                    }
                }
            } else {
                localStorage.clear();
                setIsLoading(false);
                const lockerBankInfo = getSecureItemFromSpecificStorage(LOCAL_STORAGE, LS_LOCKER_BANK_INFO);
                ShowToast(t('error_msg_scanned_qr_not_valid', getUnitLabelParams(lockerBankInfo?.LockerBankType, t)), TOAST_ERROR);
                history.replace({ pathname: '/' });
            }
        } catch (error) {
            setIsLoading(false);
            localStorage.clear();
            console.error("LandingPage.js - validateDomainAndLockerBankId", error);
            history.replace({ pathname: '/' });
        }
    }

    useEffect(() => {
        if (initialRender.current) {
            initialRender.current = false;
            validateDomainAndLockerBankId();
        }
    }, [domainAndLockerBankInfoInBase64, history]);

    const handleRedirectToHomePage = () => {
        setDialogVisible(false);
        history.replace('/');
    }

    return (
        <Box>
            <CustomDialog
                dialogVisible={dialogVisible}
                handleAccept={handleRedirectToHomePage}
                dialogTitle={t('page_title_error')}
                dialogContentText={t(dialogContentText)}
                buttonTwoTitle={t('goToHomePage')}
                buttonProps={{ buttonTwo: { type: BUTTON_PRIMARY } }}
            />
            {isLoading && (<CircularProgressLoader message={loadingMessage} />)}
        </Box>
    );
}

export default LandingPage
